

<template>
  <div>
    <header class="header">
      <h1 class="header-title">Users_ecc</h1>
    </header>
 <p>  To have a list of the user and what people they've registered for performance and training purposes</p>
    <div class="container">
      <ais-instant-search
        :search-client="searchClient"
        index-name="Users_ecc"
      >
    
        <div class="search-panel">
        
          <div class="search-panel__results">
            <ais-configure
  :hits-per-page.camel="4"
  :distinct="true"
  :analytics="false"
  
/>
            <ais-search-box placeholder="Search here…" class="searchbox" />
            <ais-hits :transform-items="transformItems">
           
              <template slot="item" slot-scope="{ item }">
                 <p> {{item.objectID}} </p>
                 <p> {{item.first_name}}  </p>
                <p> {{item.lalogst_name}} </p>
                <p>Type :  {{item.type}} </p>
                 <button @click="log(item.objectID)">show Users</button>
              </template>
            </ais-hits>
            <div class="pagination"><ais-pagination  /></div>

          </div>

        </div>
      </ais-instant-search>
    </div>
  </div>
</template>
<script>

import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';
import { constants } from 'fs';

export default {
  data() {
    return {
      searchClient: algoliasearch(
       "0EYAT8GY4A", 
       "f4241ac047f713e6dced0f85dc7e7e99"

      ),
  
    };

  },
  methods: {
    log(ID){
        console.log("ID "+ID)

    },

       transformItems2(items) {
        return items.map(item =>
          Object.assign({}, item, {
            first_name: item.first_name.toUpperCase(),
          })
        );
      },
      transformItems(items) {
        return items.filter(function (item) {
          return item.type == "M";
          });
      },
    },
}
</script>

​

<style>

body,

h1 {

  margin: 0;

  padding: 0;

}

​

body {

  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,

    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

}

​

.header {

  display: flex;

  align-items: center;

  min-height: 50px;

  padding: 0.5rem 1rem;

  background-image: linear-gradient(to right, #4dba87, #2f9088);

  color: #fff;

  margin-bottom: 1rem;

}

​

.header a {

  color: #fff;

  text-decoration: none;

}

​

.header-title {

  font-size: 1.2rem;

  font-weight: normal;

}

​

.header-title::after {

  content: ' ▸ ';

  padding: 0 0.5rem;

}

​

.header-subtitle {

  font-size: 1.2rem;

}

​

.container {

  max-width: 1200px;

  margin: 0 auto;

  padding: 1rem;

}

​

.search-panel {

  display: flex;

}

​

.search-panel__filters {
  flex: 1;
  margin-right: 1em;

}

.search-panel__results {
  flex: 3;
}
.searchbox {
  margin-bottom: 2rem;
}
.pagination {

  margin: 2rem auto;

  text-align: center;

}

.btn-group button {
  background-color: #4CAF50; /* Green background */
  border: 1px solid green; /* Green border */
  color: white; /* White text */
  padding: 10px 24px; /* Some padding */
  cursor: pointer; /* Pointer/hand icon */
  float: left; /* Float the buttons side by side */
}

/* Clear floats (clearfix hack) */
.btn-group:after {
  content: "";
  clear: both;
  display: table;
}

.btn-group button:not(:last-child) {
  border-right: none; /* Prevent double borders */
}

/* Add a background color on hover */
.btn-group button:hover {
  background-color: #3e8e41;
}

</style>




// WEBPACK FOOTER //
// src/pages/widgets/algolia.vue